<template>
  <!-- 顶部导航 -->
  <div class="header">
    <div class="nav-topbar">
      <div class="container">
        <div class="left">
          <!-- <div>选择城市：</div> -->
          <el-select v-model="defCityName" filterable size="small" placeholder="请选择" value-key="id"
            @change="changeCity($event)">
            <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
          <div class="dropdown">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ !userInfo.nickName ? '暂无昵称' : userInfo.nickName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">个人信息</el-dropdown-item>
                <el-dropdown-item command="2">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <iframe id="geoPage"
                  width=0
                  height=0
                  frameborder=0
                  style=""
                  scrolling="no"
                  src="https://apis.map.qq.com/tools/geolocation?key=J4OBZ-EONKG-CMOQB-I5KJR-ET2MS-T7F5W&referer=myapp">

          </iframe> -->
        </div>
        <div class="right" v-if="tokenShow">
          <div class="name" @click="jumpMovieOrder">电影订单<i class="el-icon-arrow-down el-icon--right"></i></div>
          <div class="line"></div>
          <div class="name" @click="jumpOrder">我的订单<i class="el-icon-arrow-down el-icon--right"></i></div>
          <div class="line"></div>
          <div class="name" @click="toPersonalCenter">个人中心<i class="el-icon-arrow-down el-icon--right"></i></div>
          <div class="line"></div>
          <div class="name" @mouseenter.stop="showCode = true" @mouseleave.stop="showCode = false">
            手机商城
            <div class="box" v-if="showCode">
              <img src="/images/xcx_icon.png" class="img" alt="">
            </div>
          </div>
          <!-- <div class="box" v-if="showCode">
            <img src="/images/xcx_icon.png" class="img" alt="">
          </div> -->
        </div>
        <div class="right" v-else>
          <div class="login-box" @click="goLogin">
            <span>请先<span class="login">登录</span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-headers">
      <div class="
         box1">
        <a href="/#/index">
          <div class="left">
            <img class="logo" src="/images/logo1.png" alt />
            <div class="line"></div>
            <div class="name">汇采实业直营商城</div>
          </div>
        </a>

        <div class="inp_box">
          <!-- <img src="/images/search_gray.png" alt=""> -->
          <!-- <div class="word">请输入关键词</div> -->
          <input type="text" v-model="keyword" placeholder="请输入关键词" @keyup.enter="jumpList('', '')" />
          <div class="btn" :style="'background-color:' + themeColor" @click="jumpList('', '')">搜索</div>
        </div>
        <div class="car_box" @click="jumpCar">
          <!-- <i class="el-icon-shopping-cart-2"></i> -->
          <span class="word">我的购物车</span>
          <span class="num">{{ cartNum }}</span>
        </div>
      </div>
      <div class="box2">
        <div class="fenlei">
          <div class="name-box" :class="tabIndex == 0 ? 'nameSelect' : ''" @click.stop="jumpHome()">
            <img v-if="tabIndex == 0" src="/images/home/hui.png" alt="">
            <img v-else src="/images/home/hui11.png" alt="">
            <span class="word">特惠专区</span>
          </div>
        </div>
        <div class="tabs" :style="'color:' + fontsColor">
          <div class="word" @click="jumpModule(1)" :class="tabIndex == 1 ? 'nameSelect' : ''">
            <img v-if="tabIndex == 1" src="/images/home/jing.png" alt="">
            <img v-else src="/images/home/jing11.png" alt="">
            <span>京东专区</span>
          </div>
          <div class="word" @click="jumpModule(2)" :class="tabIndex == 2 ? 'nameSelect' : ''">
            <img v-if="tabIndex == 2" src="/images/home/cake.png" alt="">
            <img v-else src="/images/home/cake11.png" alt="">
            <span>蛋糕专区</span>
          </div>
          <div class="word" @click="jumpModule(3)" :class="tabIndex == 3 ? 'nameSelect' : ''">
            <img v-if="tabIndex == 3" src="/images/home/movie.png" alt="">
            <img v-else src="/images/home/movie11.png" alt="">
            <span>电影专区</span>
          </div>
          <div class="word" @click="jumpModule(4)" :class="tabIndex == 4 ? 'nameSelect' : ''">
            <img v-if="tabIndex == 4" src="/images/home/card.png" alt="">
            <img v-else src="/images/home/card11.png" alt="">
            <span>虚拟卡券</span>
          </div>
          <!-- <div class="word"
               @click="jumpIntegral">积分商城</div> -->
          <div v-if="this.columnList.length == 0"></div>
          <div class="word" v-else v-for="(item, index) in columnList" @click="jumpColumn(item)" :key="index"
            :class="tabIndex == 5 ? 'nameSelect' : ''">
            <img v-if="tabIndex == 5" src="/images/home/lei.png" alt="">
            <img v-else src="/images/home/lei11.png" alt="">
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { loadBMap } from '@/utils/loadResources';
export default {
  name: 'nav-header',
  props: {
    tabIndex: {
      type: Number,
      default: 0
    },
    keyName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      keyword: '',
      firstList: [],
      secondList: [],
      hoverIndex: null,
      tokenShow: false,
      userInfo: {},
      columnList: [],
      cartNum: 0,
      companyActivity: '',
      show: false,
      defCityName: '',
      cityId: '',
      cityList: [],
      isLocation: false,
      showCode: false,//展示小程序二维码
    };
  },
  watch: {
    keyName: {
      handler: function (newVal) {
        this.keyword = newVal
      },
      immediate: true
    }
  },
  created() {
    // this.$store.dispatch('saveCakeCityId', '')
    // this.$store.dispatch('saveCakeCityName', '')
    // this.$store.dispatch('saveCakeCityLocation', {})
    window.initBaiduMapScript = () => {
      console.log(BMap);
      this.getlocation();
    }
    loadBMap('initBaiduMapScript');
    this.cityId = this.cakeCityId

    // 主题色
    this.$store.dispatch('saveThemeColor', '#ff0000')
  },
  mounted() {

    if (!localStorage.getItem('wckj-Token')) {
      this.tokenShow = false
    } else {
      this.tokenShow = true
    }
    this.getColumn()
    this.getCityList()
    if (localStorage.getItem('wckj-Token')) {
      this.getUserInfo()
      this.getCartNum()
      this.getActivity()
    }
    console.log(this.themeColor, 215);

  },
  computed: {
    ...mapState(['token', 'cakeCityId', 'cakeCityName', 'cakeCityLocation', 'navBack', 'startColor', 'endColor', 'backColors', 'fontsColor', 'themeColor'])
  },
  methods: {
    // 切换城市
    changeCity(e) {
      this.$store.dispatch('saveCakeCityId', e.id)
      this.$store.dispatch('saveCakeCityName', e.name)
    },
    // 登录
    goLogin() {
      this.$router.push('/login');
    },
    jumpHome() {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$router.push('/index')
    },
    // 搜索、跳转商品列表
    jumpList(item, type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      console.log(item);
      console.log(this.tabIndex);
      console.log("this.tabIndex");
      if (item.categoryType == 2) {
        this.$store.dispatch('saveCakeParams', '')
        this.$router.push('/cakeList')
      } else if (this.tabIndex == 0) {
        this.$store.dispatch('saveCategoryTitle', item.name)
        this.$store.dispatch('saveCategoryId', item.id)
        this.$store.dispatch('saveRecommendType', '')
        this.$store.dispatch('saveBrandId', '')
        let goodsInfo = {
          tabIndex: 1,
          keyword: this.keyword,
          brandId: '',
          thirdId: item.id,
          categoryTitle: item.name,
          pageNum: 1,
          sortField: '',
          sortAsc: true,
          recommendType: ''
        }
        this.$store.dispatch('saveWebGoodsInfo', JSON.stringify(goodsInfo))
        this.$router.push({
          name: 'goodsList'
        });
      } else {
        this.$emit('search', this.keyword)
      }
    },
    handleCommand(e) {
      if (e == 1) {
        this.$router.push({
          name: 'userInfo',
        });
      } else if (e == 2) {
        this.$confirm('确认退出吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
          this.$router.push('/login')
          // this.$cookie.set('wckj-Token', '', { expires: '-1' });
          localStorage.removeItem('wckj-Token')
          this.$store.dispatch('saveToken', '');
        }).catch(() => {
          console.log('取消');
        });
      }
    },
    // 跳转电影订单
    jumpMovieOrder() {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$store.dispatch('saveMessageType', '')
      this.$store.dispatch('savePersonType', 11)
      this.$router.push('/movieOrderList');
    },
    // 跳转我的订单
    jumpOrder() {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$store.dispatch('saveMessageType', '')
      this.$store.dispatch('savePersonType', 1)
      this.$store.dispatch('saveOrderType', 1)
      this.$router.push('/orderList');
    },
    // 跳转个人中心
    toPersonalCenter() {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$store.dispatch('saveMessageType', '')
      this.$store.dispatch('savePersonType', '')
      this.$router.push('/userInfo');
    },
    // 跳转活动专区
    jumpActivity() {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$router.push({
        name: "activityList",
      });
    },
    // 跳转模块
    jumpModule(type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (type == 1) {
        this.$store.dispatch('saveJDGoodsInfo', '')
        this.$router.push('/jdList');
      } else if (type == 2) {
        this.$store.dispatch('saveCakeParams', '')
        this.$router.push('/cakeList')
      } else if (type == 3) {
        this.$store.dispatch('saveMovieInfo', {})
        this.$router.push('/movieZone')
      } else {
        // this.$message.warning('敬请期待！')
        this.$store.dispatch('saveCouponInfo', '')
        this.$router.push('/couponList')
      }
    },
    // 跳转积分商城
    jumpIntegral() {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$router.push({
        name: "integralList",
      });
    },
    // 跳转栏目
    jumpColumn(item) {
      this.$store.dispatch('saveColumnId', item.id)
      this.$router.push({
        name: "columnList",
      });
    },
    // 跳转购物车
    jumpCar() {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$router.push('/cart');
    },
    // 获取栏目信息
    getColumn() {
      this.$api.mall.getColumnAll().then((res) => {
        console.log(res, '栏目信息');
        if (res.code == 200) {
          this.columnList = res.data
        }
      });
    },
    // 获取个人信息
    getUserInfo() {
      this.$api.mall.getInfo().then((res) => {
        console.log(res, '个人信息');
        if (res.code == 200) {
          this.userInfo = res.data.userInfo
        }
      });
    },
    // 获取购物车数量
    getCartNum() {
      this.$api.mall.getCarCount().then(res => {
        if (res.code == 200) {
          this.$store.dispatch('saveCarCount', res.data)
          this.cartNum = res.data
        }
      })
    },
    // 获取活动
    async getActivity() {
      await this.$api.mall.getCompanyActivity().then((res) => {
        console.log(res, '活动');
        if (res.code == 200) {
          if (res.data) {
            this.companyActivity = res.data
          }
        }
      });
    },
    // getLocation () {
    //   let that = this
    //   console.log(that.cakeCityId, '城市id');
    //   console.log(that.cakeCityName, '城市名字');
    //   if (!that.cakeCityId) {
    //     window.addEventListener('message', function (event) {
    //       if (event.data != null) {//这个会获取到四条数据，其中有一条数据为null，然后你如果是用变量去获取，会报错
    //         if (event.data.module == 'geolocation') {//去掉一条null后还有一条杂数据，里面没啥东西，然后你要是用变量获取位置还是会报错，所有过滤掉非该类型的数据
    //           if (this.isLocation) {
    //             return
    //           }
    //           console.log(event.data, 330);// 显示你当前位置，里面有国家、省份、市、经纬度、邮政编码
    //           that.isLocation = true
    //           that.defCityName = event.data.city
    //           if (!that.cityId) {
    //             that.getCityIdByCityName()
    //           }
    //         }
    //       }
    //     }, false);
    //   } else {
    //     that.defCityName = that.cakeCityName
    //     that.$forceUpdate()
    //   }
    // },
    getlocation() {
      // let that = this
      // if (!that.cakeCityId) {
      //   this.$nextTick(function () {
      //     try {
      //       const geolocation = new BMap.Geolocation();
      //       geolocation.getCurrentPosition(function (res) {
      //         console.log(res, "aaaa");
      //         if (that.isLocation) {
      //           return
      //         }
      //         console.log(res.address.city, 330);// 显示你当前位置，里面有国家、省份、市、经纬度、邮政编码
      //         that.isLocation = true
      //         that.defCityName = res.address.city
      //         let obj = {
      //           longitude: res.longitude,
      //           latitude: res.latitude
      //         }
      //         that.$store.dispatch('saveCakeCityLocation', obj)
      //         if (!that.cityId) {
      //           that.getCityIdByCityName()
      //         }
      //       });
      //     } catch (e) {
      //       console.log(e)
      //     }
      //   })
      // } else {
      //   that.defCityName = that.cakeCityName
      //   that.$forceUpdate()
      // }
      let that = this
      if (!that.cakeCityId) {
        this.$api.mall.getIpLngAndLat().then((res) => {
          console.log(res, '位置信息');
          if (res.code == 200) {
            if (!res.data.content) {
              that.defCityName = '郑州市'
              let obj = {
                longitude: 113.63141921,
                latitude: 34.75343885
              }
              this.$store.dispatch('saveCakeCityLocation', obj)
              that.getCityIdByCityName()
              that.getMovieByCityName()
            } else {
              that.isLocation = true
              console.log(res.data.content.address_detail.city);

              that.defCityName = res.data.content.address_detail.city
              let obj = {
                longitude: res.data.content.point.x,
                latitude: res.data.content.point.y
              }
              that.$store.dispatch('saveCakeCityLocation', obj)
              if (!that.cityId) {
                that.getCityIdByCityName()
                that.getMovieByCityName()
              }
            }

          }
        });
      } else {
        that.defCityName = that.cakeCityName
        that.$forceUpdate()
      }
    },
    // 通过城市名获取城市id
    getCityIdByCityName() {
      this.$api.mall.getCityIdByCityName({
        cityName: this.defCityName
      }).then((res) => {
        console.log(res, '城市id');
        if (res.code == 200) {
          this.cityId = res.data
          this.$store.dispatch('saveCakeCityId', res.data)
          this.$store.dispatch('saveCakeCityName', this.defCityName)
        }
      });
    },
    // 根据城市名字获取城市信息 电影
    getMovieByCityName() {
      this.$api.mall.getMovieByCityName({
        cityName: this.cakeCityName
      }).then((res) => {
        if (res.code == 200) {
          this.$store.dispatch('saveMovieCityId', res.data.cityId)
          this.$store.dispatch('saveMovieCityName', res.data.cityName)
        }
      })
    },
    // 获取城市列表
    getCityList() {
      this.$api.mall.getCityList().then((res) => {
        console.log(res, '城市列表');
        if (res.code == 200) {
          this.cityList = res.data
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  cursor: pointer;

  .nav-topbar {
    height: 35px;
    line-height: 35px;
    background-color: #F5F5F5;
    color: #b0b0b0;

    .container {
      width: 100%;
      display: flex;
      justify-content: space-between !important;
      align-items: center;
      padding: 0 200px;
      box-sizing: border-box;

      .left {
        display: flex;
        align-items: center;

        .el-select {
          width: 150px;
          border-color: transparent;

          ::v-deep .el-input__inner {
            border: none;
            background-color: rgba(0, 0, 0, 0);
            font-size: 12px;
            color: #2B2B2B;
          }
        }

        .el-input {
          border: none !important;
        }

        .el-select__caret {
          height: 32px;
        }

        .dropdown {
          margin-left: 16px;
        }
      }

      .right {
        display: flex;
        align-items: center;

        .line {
          width: 1px;
          height: 14px;
          background-color: #cccccc;
          margin: 0 14px;
        }

        .name {
          font-size: 14px;
          color: #4c4948;
        }

        .login-box {
          width: 100px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 16px;
          color: #000;

          .login {
            color: #ff0000;
            font-weight: bold;
            margin-left: 3px;
          }
        }

        .box {
          width: 200px;
          height: 200px;
          background-color: #fff;
          box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 50px;
          right: 64px;
          z-index: 888;

          .img {
            width: 180px;
            height: 180px;
            display: block;
          }
        }
      }
    }
  }

  .nav-headers {
    width: 100%;
    // height: 162px;
    background: #FFFFFF;
    padding: 25px 113px 0;
    box-sizing: border-box;
    border-bottom: 2px solid #FA2C19;

    .box1 {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        align-items: center;

        .logo {
          width: auto;
          height: 40px;
        }

        .line {
          width: 1px;
          height: 28px;
          background-color: #F5F5F5;
          margin: 0 10px;
        }

        .name {
          font-size: 24px;
          color: #044FA0;
          font-weight: bold;
        }
      }

      .inp_box {
        width: 710px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 5px;
        border: 1px solid #FF6767;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        margin: 0 30px;

        img {
          width: auto;
          height: 16px;
        }

        .word {
          flex: 1;
          height: 42px;
          line-height: 42px;
          border: none;
          font-size: 14px;
          padding: 0 10px;
          box-sizing: border-box;
          color: #999;
        }

        >input {
          flex: 1;
          border: none;
          font-size: 14px;
          padding: 0 10px;
          box-sizing: border-box;
          color: #999;
        }

        .btn {
          width: 95px;
          height: 40px;
          background: #FA2C19;
          border-radius: 5px;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          color: #FFFFFF;
          color: #ffffff;
          border-radius: 0;
        }
      }

      .car_box {
        height: 40px;
        background: #FFFFFF;
        border-radius: 6px;
        border: 1px solid #EFEFEF;
        padding: 0 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        i {
          font-size: 24px;
          color: #004098;
        }

        .word {
          font-size: 14px;
          color: #222222;
          box-sizing: border-box;
        }

        .num {
          height: 18px;
          display: flex;
          align-items: center;
          padding: 0 5px;
          box-sizing: border-box;
          background-color: #FA2C19;
          border-radius: 9px;
          font-size: 12px;
          color: #FFFFFF;
          margin-left: 10px;
        }
      }
    }

    .box2 {
      width: 100%;
      display: flex;
      align-items: center;
      margin-top: 20px;

      .fenlei {
        height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .name-box {
          padding: 0 8px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 19px;
          }

          .word {
            font-size: 16px;
            color: #0D0D0D;
            font-weight: bold;
            margin-left: 7px;
          }
        }
      }

      .nameSelect {
        background: #FA2C19;
        border-radius: 4px 4px 0px 0px;

        .word {
          color: #FFFFFF !important;
        }

        span {
          color: #FFFFFF !important;
        }
      }

      .tabs {
        flex: 1;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        color: #4c4948;

        .word {
          height: 38px;
          padding: 0 8px;
          // flex: 1;
          font-size: 16px;
          color: #0D0D0D;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 54px;

          img {
            width: 19px;
          }

          span {
            font-size: 16px;
            color: #0D0D0D;
            font-weight: bold;
            margin-left: 7px;
          }
        }

        .check {
          color: #ffffff;
        }
      }
    }
  }
}

.el-dropdown-link {
  cursor: pointer;
  color: #4c4948;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>